import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["checked"]
const _hoisted_2 = { class: "fs-regular text-start" }
const _hoisted_3 = ["innerHTML"]

import {
  computed,
} from 'vue';

import IconCheck from '@/components/inputs/IconCheck.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: {
  modelValue: {
    type: Boolean,
    default: () => false,
  },
  error: {
    type: [String, Array],
    required: false,
    default: () => '',
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;




const hasError = computed(() => (props.error !== null ? props.error.length > 0 : false));

const errorMessage = computed(() => {
  if (hasError.value) {
    return Array.isArray(props.error)
      ? props.error[0]
      : props.error;
  }

  return '';
});

const value = computed({
  get(): unknown {
    return props.modelValue;
  },
  set(newValue: unknown): void {
    emit('update:modelValue', newValue);
  },
});

const emitInput = (event: {
  target: {
    checked: boolean,
  }
}) => {
  value.value = event.target.checked;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["io-shop-checkbox", {'invalid': hasError.value}])
  }, [
    _createElementVNode("label", null, [
      _createElementVNode("div", null, [
        _createElementVNode("input", {
          type: "checkbox",
          class: "base-input__input",
          checked: __props.modelValue,
          onInput: emitInput
        }, null, 40, _hoisted_1),
        _createElementVNode("span", null, [
          _createVNode(IconCheck)
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default"),
        (hasError.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "io-shop-input--message fs-small",
              innerHTML: errorMessage.value
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})